import { useEffect, useMemo, useState } from "react";
import { collection, doc, onSnapshot, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";

const ROLE_OPTIONS = [
	{ value: "user", label: "Uzytkownik" },
	{ value: "moderator", label: "Moderator" },
	{ value: "admin", label: "Admin" }
];

function UsersAdm({ userEmail, onLogout, userRole }) {
	const [users, setUsers] = useState([]);
	const [selectedRoles, setSelectedRoles] = useState({});
	const [status, setStatus] = useState({ type: "", message: "" });
	const [savingId, setSavingId] = useState("");

	useEffect(() => {
		const unsubscribe = onSnapshot(
			collection(db, "users"),
			(snapshot) => {
				const items = snapshot.docs.map((docSnap) => ({
					id: docSnap.id,
					...docSnap.data()
				}));
				setUsers(items);
				setStatus({ type: "", message: "" });
			},
			(error) => {
				setStatus({
					type: "error",
					message: error.message || "Nie udalo sie pobrac uzytkownikow."
				});
			}
		);

		return () => unsubscribe();
	}, []);

	const sortedUsers = useMemo(() => {
		return [...users].sort((a, b) => {
			const aEmail = String(a.email || "").toLowerCase();
			const bEmail = String(b.email || "").toLowerCase();
			return aEmail.localeCompare(bEmail);
		});
	}, [users]);

	useEffect(() => {
		const nextSelected = {};
		users.forEach((item) => {
			nextSelected[item.id] = item.role || "user";
		});
		setSelectedRoles(nextSelected);
	}, [users]);

	const handleRoleSelect = (userId, role) => {
		setSelectedRoles((prev) => ({
			...prev,
			[userId]: role
		}));
	};

	const handleRoleChange = async (userId, role) => {
		setSavingId(userId);
		setStatus({ type: "", message: "" });
		try {
			await updateDoc(doc(db, "users", userId), {
				role,
				updatedAt: serverTimestamp()
			});
			setStatus({ type: "success", message: "Zmieniono role uzytkownika." });
		} catch (error) {
			setStatus({
				type: "error",
				message: error.message || "Nie udalo sie zmienic roli."
			});
		} finally {
			setSavingId("");
		}
	};

	return (
		<div className="HomeShell">
			<Navbar menuItems={menuItems} onLogout={onLogout} userRole={userRole} />

			<div className="WelcomePanel">
				<p className="Badge">Uzytkownicy</p>
				<h1 className="Title">Role uzytkownikow</h1>
				<p className="Subtitle">Zalogowano jako {userEmail}.</p>

				<div className="CardTable">
					<table className="Table">
						<thead>
							<tr>
								<th>E-mail</th>
								<th>Rola</th>
								<th>Akcje</th>
							</tr>
						</thead>
						<tbody>
							{sortedUsers.length === 0 ? (
								<tr>
									<td colSpan="3">Brak uzytkownikow.</td>
								</tr>
							) : (
								sortedUsers.map((item) => (
									<tr key={item.id}>
										<td>{item.email || item.id}</td>
										<td>
											<select
												className="Input"
																value={selectedRoles[item.id] || item.role || "user"}
																onChange={(event) =>
																	handleRoleSelect(item.id, event.target.value)
																}
												disabled={savingId === item.id}
											>
												{ROLE_OPTIONS.map((option) => (
													<option key={option.value} value={option.value}>
														{option.label}
													</option>
												))}
											</select>
										</td>
										<td>
															<button
																className="Button SmallButton"
																type="button"
																onClick={() =>
																	handleRoleChange(
																		item.id,
																		selectedRoles[item.id] || item.role || "user"
																	)
																}
																disabled={
																	savingId === item.id ||
																	(selectedRoles[item.id] || item.role || "user") ===
																		(item.role || "user")
																}
															>
																{savingId === item.id ? "Zapisywanie..." : "Zapisz"}
															</button>
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>

				{status.message ? (
					<p className={status.type === "error" ? "Error" : "Success"}>
						{status.message}
					</p>
				) : null}
			</div>
		</div>
	);
}

export default UsersAdm;
